import React from 'react';
import { MenuIcon } from 'lucide-react';
interface TopBarProps {
  onOpenMenu: () => void;
}
export function TopBar({
  onOpenMenu
}: TopBarProps) {
  return <header className="sticky top-[76px] z-50 flex h-[60px] shrink-0 items-center justify-between gap-4 border-b border-line bg-ink/95 px-4 backdrop-blur-md sm:px-6" data-id="element-96" data-mp="sp849rtinuax">
      <div className="flex min-w-0 items-center gap-3" data-id="element-97" data-mp="jvlfwmrn1tbr">
        <button type="button" onClick={onOpenMenu} aria-label="Abrir menú" className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-md border border-white/10 text-white/70 transition-colors duration-150 ease-out hover:border-cyan-vip/50 hover:text-cyan-vip focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-cyan-vip lg:hidden" data-id="element-98" data-mp="17knutmuw182k">
          <MenuIcon className="h-4 w-4" aria-hidden="true" data-id="element-99" data-mp="3ic656giho4a5" />
        </button>

        <div className="min-w-0" data-id="element-100" data-mp="3nbincnyf0n6e">
          <p className="font-mono text-[9px] uppercase tracking-[0.28em] text-cyan-vip sm:text-[10px]" data-id="element-101" data-mp="3nck0qz2wllra">
            indicadoresvip.com
          </p>
          <p className="truncate font-display text-[17px] leading-tight text-white sm:text-[20px]" data-id="element-102" data-mp="3co14e87wv835">
            Indicadores <span className="text-gold-vip" data-id="element-103" data-mp="3mkdu6v0c51sm">VIP</span>
            <span className="ml-2 hidden text-[13px] italic text-white/30 sm:inline" data-id="element-104" data-mp="3mlyr2ra4gwtn">
              — Protocolo de Apertura
            </span>
          </p>
        </div>
      </div>

      <div className="flex shrink-0 items-center gap-2.5 text-right" data-id="element-105" data-mp="3vk0qj2e7jhet">
        <span className="relative flex h-2 w-2" data-id="element-106" data-mp="3rjqmhv9z712l">
          <span className="absolute inline-flex h-full w-full rounded-full bg-cyan-vip opacity-60" data-id="element-107" data-mp="3riywczz5dvjp" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-cyan-vip" data-id="element-108" data-mp="94pqamlftiv9" />
        </span>
        <span className="leading-tight" data-id="element-109" data-mp="476ctowkda4d">
          <span className="block font-mono text-[9px] uppercase tracking-[0.22em] text-cyan-vip sm:text-[10px]" data-id="element-110" data-mp="j3f9cip2l9d3">
            Market Data
          </span>
          <span className="hidden font-mono text-[10px] text-white/35 sm:block" data-id="element-111" data-mp="e658m6w8db9y">
            Live · TradingView
          </span>
        </span>
      </div>
    </header>;
}